/*
  cart-recent-first.js

  Shopify appends a new line to the end of the cart and leaves a quantity
  change where it is, so the item a shopper has just acted on can sit far down
  a long list — or off the bottom of the drawer entirely.

  There is no cart API for reordering lines (only remove-and-re-add, which
  would lose the line's properties and its place in any discount already
  applied), so the order is presentational: recently touched variants are
  remembered and their rows are moved to the top after each render. The cart
  Shopify holds is untouched.
*/
(function () {
  'use strict';

  var KEY = 'poco_cart_recent';
  var MAX = 40;
  /* Long enough to survive browsing between pages, short enough that an old
     session does not reshuffle a cart the shopper returns to days later. */
  var TTL = 1000 * 60 * 60 * 6;

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY)) || [];
      var cut = Date.now() - TTL;
      return raw.filter(function (e) { return e && e.t > cut; });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  }

  /* Most recent first. */
  function remember(variantId) {
    if (!variantId) return;
    var id = String(variantId);
    var list = read().filter(function (e) { return e.id !== id; });
    list.unshift({ id: id, t: Date.now() });
    write(list);
    reorderSoon();
  }

  function rank(variantId) {
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === String(variantId)) return i;
    }
    return Infinity;
  }

  /* Containers whose direct children are the cart lines. */
  var GROUPS = [
    { host: '.cart-items tbody', row: 'tr.cart-item' },   // drawer + main cart table
    { host: '.cr__items', row: '.cr__item' }              // cart page
  ];

  function reorder() {
    GROUPS.forEach(function (g) {
      document.querySelectorAll(g.host).forEach(function (host) {
        var rows = Array.prototype.slice.call(host.querySelectorAll(':scope > ' + g.row));
        if (rows.length < 2) return;

        /* Decorate-sort-undecorate keeps the sort stable: untouched rows hold
           their existing order behind the recent ones. */
        var decorated = rows.map(function (row, i) {
          return { row: row, i: i, r: rank(row.getAttribute('data-variant-id')), f: row.getAttribute('data-free') === '1' ? 1 : 0 };
        });

        decorated.sort(function (a, b) {
          if (a.f !== b.f) return a.f - b.f;
          return a.r === b.r ? a.i - b.i : a.r - b.r;
        });

        var changed = decorated.some(function (d, i) { return d.i !== i; });
        if (!changed) return;

        decorated.forEach(function (d) { host.appendChild(d.row); });
      });
    });
  }

  var pending = null;
  function reorderSoon() {
    clearInterval(pending);
    /* Renders land in pieces (section swap, then the drawer opening), so the
       pass is repeated briefly rather than fired once and hoped for. Each run
       is wrapped: a failure here must never escape into the caller's promise
       chain, or the drawer's own open() would be skipped with it. */
    var runs = 0;
    pending = setInterval(function () {
      try { reorder(); } catch (e) {}
      if (++runs > 6) clearInterval(pending);
    }, 120);
  }

  /* ---- what counts as "touched" ---------------------------------------- */

  /* The same POSTs the rest of the cart code makes; watched here rather than
     patched into each caller. */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var body = init && init.body;

      var variant = null;
      if (typeof url === 'string' && /\/cart\/(add|change)(\.js)?/.test(url)) {
        try {
          if (typeof body === 'string') {
            var j = JSON.parse(body);
            variant = j.id;
          } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
            variant = body.get('id');
          }
        } catch (e) {}
      }

      var out = nativeFetch.apply(this, arguments);

      if (variant) {
        /* A detached branch on purpose: the caller gets `out` untouched, so
           nothing here can delay or reject what it is waiting on. */
        out.then(function () {
          /* change.js takes a line key, not a variant id. The key is matched
             back to its variant from the returned cart. */
          if (/^\d+$/.test(String(variant))) {
            remember(variant);
          } else {
            nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var hit = (cart.items || []).filter(function (it) { return it.key === variant; })[0];
                if (hit) remember(hit.id);
              })
              .catch(function () {});
          }
        }).catch(function () {});
      }

      return out;
    };
  }

  document.addEventListener('cart:refresh', reorderSoon);
  document.addEventListener('cart:update', reorderSoon);
  document.addEventListener('cart-update', reorderSoon);
  document.addEventListener('cart:section-refreshed', reorderSoon);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorder);
  } else {
    reorder();
  }
})();
